import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {faLock, faUser} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginGroup: FormGroup;
  faUser = faUser;
  faLock = faLock;
  constructor(private fb: FormBuilder,
              private router: Router,
              private toastr: ToastrService,
              private authService: AuthService) { }

  ngOnInit() {
    this.loginGroup = this.fb.group({
      cuenta: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  getUser() {
    this.authService.getUser()
      .subscribe((user: any) => {
        console.log(user);
        this.authService.setAuth(user);
      });
  }
  login() {
    this.authService.login(this.loginGroup.value)
      .subscribe((res: any) => {
        this.getUser();
        if (res.success) {
          switch (res.success.usuario.tipo_usuario) {
            case 'administrador':
              this.router.navigate(['/admin']); break;
            case 'administrativo':
              this.router.navigate(['/admin']); break;
            case 'estudiante':
              this.router.navigate(['/estudiante']);break;
            case 'docente':
              this.router.navigate(['/docente']);break;
          }
        }
        this.toastr.success('Accediendo al sistema', 'Autenticado');
      }, (error: any) => {
        this.loginGroup.reset();
        this.toastr.error('Credenciales incorrectas', 'Sin acceso');
      });
  }

}
